<app-single-folder-form [folder]="defaultFolderViewModel" [editable]="true" (onSubmitFolderHandler)="createFolder($event)">
</app-single-folder-form>
